import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AllocationMethodsCard,
  CommonCostChartCard,
  GlobalStandardsCard,
  GroupAccountsCard,
  GroupCard,
  OwnerCostAccountsCard,
} from './components';
import { MOCK_PORTFOLIO_ECONOMY_SETTINGS } from './mock/portfolio-economy.mock';
import { ECONOMY_LABEL_CLASS } from './economy-theme';

/**
 * Innstillinger tab. Each editable card owns its own form and saves on its own, the way
 * the agreement and portfolio cards do — saving one section neither validates nor submits
 * another. Konsern-nivå and Allokering-metoder have no editable field, so they stay plain.
 *
 * Every card except Globale standarder now fetches its own data: Konsern-nivå, Konsern-konti and
 * the two chart cards. Nothing is persisted either way — the mock-backed card folds a save back
 * into the state held here so its read-only view shows what was just saved, and the fetching cards
 * discard theirs until their PUT endpoints exist. A reload loses it in both cases.
 */
export function PortfolioEconomySettingsRoute() {
  const { t } = useTranslation('economy');

  const [settings, setSettings] = useState(MOCK_PORTFOLIO_ECONOMY_SETTINGS);

  return (
    <section className="flex flex-col gap-5">
      <p className={ECONOMY_LABEL_CLASS}>{t('settings.sectionTitle')}</p>

      <GroupCard />

      <GroupAccountsCard />

      {/* Both chart cards fetch for themselves and are READ-ONLY until EXIO-2988 ships their PUT:
          no onSave means no Rediger button. Passing a no-op instead would let the user edit, press
          Lagre and be told it saved, while nothing left the browser. */}
      <CommonCostChartCard />

      <OwnerCostAccountsCard />

      <GlobalStandardsCard
        settings={settings}
        onSave={({ marginPercent, ...globalStandards }) =>
          setSettings((current) => ({
            ...current,
            // The schema leaves the margin optional under pass-through; the settings keep
            // the absent case as an explicit null.
            globalStandards: { ...globalStandards, marginPercent: marginPercent ?? null },
          }))
        }
      />

      <AllocationMethodsCard />
    </section>
  );
}

export default PortfolioEconomySettingsRoute;
